export const FormatNigerianPhoneNumber = (phone) => {
  return "+234 "+phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3"); 
}